import {
  canSeeField,
  canUpdateField,
  canCreateField,
  isFieldDisabled,
  validateFieldPermissions,
} from 'helpers/fieldRestrictions';
import { useAppSelector } from 'helpers/hooks';
import { getPagesState } from 'selectors/pages';

export const useFieldRestrictions = (isEditMode: boolean) => {
  const pagesState = useAppSelector(getPagesState);
  const fieldRestrictions = pagesState.data?.clientPages?.render_hints?.field_restrictions;

  return {
    canSee: (fieldName: string) => canSeeField(fieldRestrictions, fieldName),
    canUpdate: (fieldName: string) => canUpdateField(fieldRestrictions, fieldName),
    canCreate: (fieldName: string) => canCreateField(fieldRestrictions, fieldName),
    isDisabled: (fieldName: string) => isFieldDisabled(fieldRestrictions, fieldName, isEditMode),
    validate: (fieldName: string, value: any) =>
      validateFieldPermissions(fieldRestrictions, fieldName, value, isEditMode),
  };
};
